
import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { User, UserLogin } from '@core/models';
import { CheckTriviaUserService, RequestsUtilityService } from '@core/services';
import { environment } from '@env';
import { catchError, map, Observable } from 'rxjs';
import { AuthService } from '@core/api-services';

@Injectable({
  providedIn: 'root',
})
export class TriviaMaticManagerGuard  {
  constructor(
    private router: Router,
    private authService: AuthService,
    private checkTriviaUserService: CheckTriviaUserService,
    private requestsUtilityService: RequestsUtilityService,
    @Inject(DOCUMENT) private document: Document
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    const token = route.queryParams.triviaUser;
    const options = this.requestsUtilityService.bearerToken(token);
    return this.checkTriviaUserService.checkUser(options).pipe(
      catchError((e) => {
        this.document.location.href = environment.triviaMaticBaseUrl;
        return null;
      }),
      map((e) => {
        this.authService.persistToStorage(e as UserLogin, { remember: false });
        this.router.navigate(['./triviamatic-manager/game/games']);
        return true;
      })
    );
  }
}
